var _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPocketPathologistIconSubmitTransparent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    enableBackground: "new 0 0 700 700",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BDABD3",
    d: "M525.05,170.92l-97.57,348c-3.16,11.24-16.43,16.05-26.05,9.43l-70.15-48.26l-0.04-0.03 c-0.01-0.01-0.03-0.02-0.05-0.04L315.17,469c-3.75-2.58-8.02-3.85-12.26-3.91c-6.72-0.1-13.38,2.85-17.81,8.52l-38.84,49.62 c-1.14,1.46-2.52,2.51-4.02,3.19c-5.93,2.69-13.62-0.55-15.01-7.79L207,413.3c-1.3-6.77-4.66-12.9-9.56-17.61 c-1.54-1.49-3.24-2.83-5.06-4.01l-88.07-56.66c-11.72-7.54-9.92-25.2,3.09-30.21l396.8-152.86c5.42-2.09,10.86-1.01,14.91,1.95 C524.12,157.52,526.99,164.02,525.05,170.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D63AB",
    d: "M315.17,469c-3.75-2.58-8.02-3.85-12.26-3.91c-6.72-0.1-13.38,2.85-17.81,8.52l-38.84,49.62 c-1.14,1.46-2.52,2.51-4.02,3.19c-1-30.62-2.93-83.78,7.97-88.01c3.74-1.45,9.02-1.13,17.09,2.34 C291.53,451.16,315.17,469,315.17,469z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9076B6",
    d: "M516.59,154.08c0,0-301.41,228.21-318.37,241.08c-0.39,0.3-0.45,0.87-0.12,1.24 c0.96,1.06,2.72,3.06,3.45,4.09c0.25,0.35,0.48,0.7,0.71,1.05c0.46,0.71,0.89,1.44,1.29,2.18c0.19,0.35,0.37,0.7,0.55,1.05 c0.96,1.92,1.73,3.94,2.3,6.03c0.22,0.82,0.42,1.65,0.58,2.5l20.24,105.33c1.15,5.97,6.58,9.23,11.78,8.67 c0.35-0.04,0.7-0.09,1.05-0.17c1.01-0.22,2-0.58,2.94-1.1c0.15-0.08,0.29-0.17,0.43-0.26c4.9-4.25,27.87-85.18,20.13-86.43 c-30.42-20.33,207.56-230.43,256.06-282.48c0.71-0.76,0.61-1.96-0.21-2.59l-0.22-0.17C518.44,153.51,517.37,153.5,516.59,154.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D63AB",
    d: "M242.29,547.47c-0.06,0.17-0.12,0.27-0.2,0.3C241.96,547.81,242.04,547.71,242.29,547.47z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x36_"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocketPathologistIconSubmitTransparent);
export default __webpack_public_path__ + "static/media/Pocket Pathologist-Icon_Submit-transparent.903c613e6e5eff8d1d13e7797d0846cc.svg";
export { ForwardRef as ReactComponent };